module.exports = __webpack_public_path__ + "img/Fenêtre pvc réno.d2a3bff1.jpg";